import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { DocumentService } from '../../service/document.service';
import { SharedClaimDocumentLink, SharedClaimDocumentLinkFormBuilder } from '../../models/SharedClaimDocumentLink';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shared-claim-document-link-manage',
  templateUrl: './shared-claim-document-link-manage.component.html',
  styleUrls: ['./shared-claim-document-link-manage.component.scss']
})
export class SharedClaimDocumentLinkManageComponent extends DialogContentBase implements OnInit {

  @Input() sharedClaimDocumentLink!: SharedClaimDocumentLink;
  editMode = false;
  sharedClaimDocumentLinkForm!: UntypedFormGroup;

  get sharedDocumentLink(): string {
    const webAppPath = environment.wepAppName ? `/${environment.wepAppName}` : '';
    return `${window.location.origin}${webAppPath}/selfCareCenter/sharedDocuments/${this.sharedClaimDocumentLink.linkHash}`;
  }

  constructor(
    public dialog: DialogRef,
    private fb: UntypedFormBuilder,
    private documentService: DocumentService,
    private formUtilsService: FormUtilsService,
    private uiNotification: UiNotificationService
  ) {
    super(dialog);
  }

  ngOnInit(): void {
    this.editMode = this.sharedClaimDocumentLink.id > 0;
    this.sharedClaimDocumentLinkForm = SharedClaimDocumentLinkFormBuilder.getForm(
      this.fb,
      this.sharedClaimDocumentLink
    );
  }

  cancel(): void {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm(): void {
    if (!this.formUtilsService.markFormGroupTouched(this.sharedClaimDocumentLinkForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.sharedClaimDocumentLink, this.sharedClaimDocumentLinkForm.value);
    this.documentService.createSharedClaimDocumentLink(this.sharedClaimDocumentLink)
      .subscribe((id) => {
        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
        this.dialog.close({ text: 'OK', newAddedId: id });
      });
  }

}
